import { Link } from "react-router-dom";
import { Heart, Sparkles, Coffee } from "lucide-react";
import { CheetahCorner, LightningBolt } from "../components/BrandAccents";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-6 py-16 sm:py-24">
      <div className="font-script text-3xl text-[#e8478e]">Hey, Hi, Hello</div>
      <h1 className="mt-2 font-display text-5xl sm:text-7xl font-black text-[#1c1815] tracking-tight">
        Meet The <em className="italic text-[#2eb6a8]">Boutique</em>
      </h1>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="md:col-span-2 space-y-6 text-[#4a4239] leading-relaxed text-lg">
          <p>
            We're two crafty ladies who were over the same basic designs… so we made our own. What started as creating pieces we loved turned into a boutique for mamas and their babies who like their style a little more fun.
          </p>
          <p>
            Think cute, bold, trendy — with a little sass mixed in.
          </p>
          <p className="font-display font-extrabold text-2xl text-[#1c1815]">
            If that sounds like you, welcome… you're gonna fit right in <span className="font-script not-italic text-[#e8478e] text-3xl">😉</span>
          </p>
        </div>
        <aside className="space-y-4">
          <div className="relative p-5 rounded-2xl bg-white border border-[#e5dccd] shadow-sm overflow-hidden">
            <CheetahCorner position="top-right" size={70} opacity={0.18}/>
            <Heart className="text-[#e8478e]" size={20} fill="currentColor"/>
            <div className="mt-2 font-display font-extrabold text-xl text-[#1c1815]">Made with love</div>
            <p className="text-sm text-[#4a4239] mt-1">Every piece is handpicked or hand-designed.</p>
          </div>
          <div className="relative p-5 rounded-2xl bg-white border border-[#e5dccd] shadow-sm overflow-hidden">
            <Sparkles className="text-[#2eb6a8]" size={20}/>
            <div className="mt-2 font-display font-extrabold text-xl text-[#1c1815]">Always on trend</div>
            <p className="text-sm text-[#4a4239] mt-1">Fresh drops weekly because we get bored fast.</p>
          </div>
          <div className="relative p-5 rounded-2xl bg-white border border-[#e5dccd] shadow-sm overflow-hidden">
            <Coffee className="text-[#9c6dde]" size={20}/>
            <div className="mt-2 font-display font-extrabold text-xl text-[#1c1815]">Powered by coffee</div>
            <p className="text-sm text-[#4a4239] mt-1">And your support, of course.</p>
          </div>
        </aside>
      </div>

      {/* Meet the Owners */}
      <section className="mt-20" data-testid="meet-the-owners">
        <div className="text-center">
          <div className="inline-flex items-center gap-3 font-script text-3xl text-[#9c6dde]">
            <Sparkles size={20} className="text-[#9c6dde]"/> Meet The Owners <Sparkles size={20} className="text-[#9c6dde]"/>
          </div>
          <h2 className="mt-1 font-display text-4xl sm:text-5xl font-black text-[#1c1815] tracking-tight">
            The Babes Behind The Boutique
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Wendy */}
          <div data-testid="owner-wendy" className="relative p-7 sm:p-9 rounded-3xl bg-white border border-[#e5dccd] shadow-sm overflow-hidden grunge-overlay">
            <CheetahCorner position="top-right" size={110} opacity={0.18}/>
            <div className="absolute top-5 right-5 hidden sm:block opacity-90">
              <LightningBolt size={22}/>
            </div>
            <div className="relative">
              <div className="font-script text-2xl text-[#9c6dde]">Edgy, Bold, Extra</div>
              <h3 className="mt-1 font-display text-4xl font-black text-[#1c1815] tracking-tight">Wendy</h3>
              <ul className="mt-5 space-y-3 text-[#4a4239]">
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#e8478e] flex-shrink-0"/>
                  <span>Mama of 2 <span className="text-[#8a8076]">(plus 2 bonus kiddos)</span> <Heart size={13} className="inline text-[#e8478e] -mt-0.5" fill="currentColor"/></span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#2eb6a8] flex-shrink-0"/>
                  <span>Sassy to the bone and a full-time sarcasm specialist</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#9c6dde] flex-shrink-0"/>
                  <span>Lover of all things goth, teal, and purple</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#e8478e] flex-shrink-0"/>
                  <span>If it's bold, edgy, or a little extra… she's probably behind it</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Alisha */}
          <div data-testid="owner-alisha" className="relative p-7 sm:p-9 rounded-3xl bg-white border border-[#e5dccd] shadow-sm overflow-hidden grunge-overlay">
            <CheetahCorner position="top-left" size={110} opacity={0.18}/>
            <div className="absolute top-5 right-5 hidden sm:block opacity-90">
              <LightningBolt size={22}/>
            </div>
            <div className="relative">
              <div className="font-script text-2xl text-[#2eb6a8]">Smart, Sweet, Sneaky-Sassy</div>
              <h3 className="mt-1 font-display text-4xl font-black text-[#1c1815] tracking-tight">Alisha</h3>
              <ul className="mt-5 space-y-3 text-[#4a4239]">
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#e8478e] flex-shrink-0"/>
                  <span>Mama of 3 <Heart size={13} className="inline text-[#e8478e] -mt-0.5" fill="currentColor"/></span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#2eb6a8] flex-shrink-0"/>
                  <span>Your go-to office babe</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#9c6dde] flex-shrink-0"/>
                  <span>Quiet and sweet — with just the right amount of sass and sarcasm</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-[#e8478e] flex-shrink-0"/>
                  <span>Smart, funny, and the calm to Wendy's chaos</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="relative mt-16 p-10 sm:p-14 rounded-3xl border border-[#e5dccd] bg-white text-center shadow-sm overflow-hidden grunge-overlay">
        <CheetahCorner position="top-left" size={100} opacity={0.16}/>
        <CheetahCorner position="bottom-right" size={100} opacity={0.16}/>
        <div className="relative">
          <div className="font-script text-3xl text-[#2eb6a8]">Come Say Hi</div>
          <h2 className="font-display text-4xl font-black text-[#1c1815] tracking-tight">Let's Connect</h2>
          <Link to="/contact" className="mt-6 inline-block bg-[#e8478e] hover:bg-[#c93875] hover:shadow-lg hover:-translate-y-0.5 text-white font-bold uppercase tracking-[0.2em] text-xs px-7 py-4 rounded-full transition-all">
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
